// frontend/src/components/Footer.tsx
import { useTranslation } from "react-i18next";

export default function Footer() {

  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-gray-50 text-xs text-gray-500 px-4 py-2 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1">
      <div className="text-center sm:text-left">{t("footer.copyright", { year })}</div>
      <div className="w-full flex gap-4 justify-center sm:w-auto sm:justify-end">
        <a href="/terms" className="hover:underline hover:text-gray-700">{t("footer.terms")}</a>
        <a href="/privacy" className="hover:underline hover:text-gray-700">{t("footer.privacy")}</a>
      </div>
    </footer>
  );
}